(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-actif-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
		if (window.mmActifPanelInit) return;
		window.mmActifPanelInit = true;

		let currentTriggerElement = null;
		let focusTrapActive = false;
		let focusTrapHandler = null;

		// Setup focus trap
		function setupFocusTrap(panel, triggerElement) {
			const focusableElements = panel.querySelectorAll(
				'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
			);

			if (focusableElements.length === 0) return;

			const firstFocusable = focusableElements[0];
			const lastFocusable = focusableElements[focusableElements.length - 1];

			currentTriggerElement = triggerElement;

			focusTrapHandler = (e) => {
				if (e.key === 'Tab') {
					if (e.shiftKey) {
						if (document.activeElement === firstFocusable) {
							e.preventDefault();
							lastFocusable.focus();
						}
					} else {
						if (document.activeElement === lastFocusable) {
							e.preventDefault();
							firstFocusable.focus();
						}
					}
				}
			};

			panel.addEventListener('keydown', focusTrapHandler);
			focusTrapActive = true;

			// Focus first focusable element
			requestAnimationFrame(() => {
				firstFocusable.focus();
			});
		}

		// Remove focus trap
		function removeFocusTrap(panel) {
			if (focusTrapActive && focusTrapHandler) {
				panel.removeEventListener('keydown', focusTrapHandler);
				focusTrapActive = false;
				focusTrapHandler = null;
			}
		}

		// Open panel function
		function openPanel(panel, triggerElement) {
			if (!panel) return;

			if (panel.hasAttribute('hidden')) {
				panel.removeAttribute('hidden');
			}

			// Update aria-expanded on trigger
			if (triggerElement) {
				triggerElement.setAttribute('aria-expanded', 'true');
			}

			requestAnimationFrame(() => {
				void panel.offsetHeight;
				panel.classList.add('mm-active');
				document.body.style.overflow = 'hidden';

				// Setup focus trap
				setupFocusTrap(panel, triggerElement);
			});
		}

		// Close panel function
		function closePanel(panel) {
			if (!panel) return;

			// Update aria-expanded on trigger
			if (currentTriggerElement) {
				currentTriggerElement.setAttribute('aria-expanded', 'false');
			}

			panel.classList.remove('mm-active');
			panel.classList.add('mm-closing');

			// Remove focus trap
			removeFocusTrap(panel);

			setTimeout(() => {
				panel.classList.remove('mm-closing');
				panel.setAttribute('hidden', '');
				document.body.style.overflow = '';

				// Return focus to trigger element
				if (currentTriggerElement) {
					currentTriggerElement.focus();
					currentTriggerElement = null;
				}
			}, 400);
		}

		// Event delegation for open buttons
		document.addEventListener('click', (e) => {
			const openBtn = e.target.closest('[data-actif-open]');
			if (openBtn) {
				e.preventDefault();
				e.stopPropagation();
				const actifId = openBtn.getAttribute('data-actif-open');
				const panel = document.getElementById('mm-actif-panel-' + actifId);
				openPanel(panel, openBtn);
				return;
			}

			// Close button
			const closeBtn = e.target.closest('[data-actif-panel-close]');
			if (closeBtn) {
				e.preventDefault();
				e.stopPropagation();
				const panel = closeBtn.closest('[data-actif-panel]');
				closePanel(panel);
				return;
			}

			// Click on overlay to close
			const panel = e.target.closest('[data-actif-panel]');
			if (panel && e.target === panel) {
				closePanel(panel);
			}
		});

		// ESC key to close
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				const activePanel = document.querySelector('[data-actif-panel].mm-active');
				if (activePanel) {
					closePanel(activePanel);
				}
			}
		});
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-member-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
        if (window.mmMemberPanelInit) return;
        
        window.mmMemberPanelInit = true;

        let currentTriggerElement = null;
        let focusTrapActive = false;
        let focusTrapHandler = null;

        function setupFocusTrap(panel, triggerElement) {
            const focusableElements = panel.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            if (focusableElements.length === 0) return;
            

            const firstFocusable = focusableElements[0];
            const lastFocusable = focusableElements[focusableElements.length - 1];
            currentTriggerElement = triggerElement;

            focusTrapHandler = (e) => {
                if (e.key === 'Tab') {
                    if (e.shiftKey) {
                        if (document.activeElement === firstFocusable) {
                            e.preventDefault();
                            lastFocusable.focus();
                        }
                    } else {
                        if (document.activeElement === lastFocusable) {
                            e.preventDefault();
                            firstFocusable.focus();
                        }
                    }
                }
            };

            panel.addEventListener('keydown', focusTrapHandler);
            focusTrapActive = true;
            requestAnimationFrame(() => firstFocusable.focus());
        }

        function removeFocusTrap(panel) {
            if (focusTrapActive && focusTrapHandler) {
                panel.removeEventListener('keydown', focusTrapHandler);
                focusTrapActive = false;
                focusTrapHandler = null;
            }
        }

        function openPanel(panel, triggerElement) {
            if (! panel) return;
            
            if (panel.hasAttribute('hidden')) 
                panel.removeAttribute('hidden');
            
            if (triggerElement) 
                triggerElement.setAttribute('aria-expanded', 'true');
            

            requestAnimationFrame(() => {
                void panel.offsetHeight;
                panel.classList.add('mm-active');
                document.body.style.overflow = 'hidden';
                setupFocusTrap(panel, triggerElement);
            });
        }

        function closePanel(panel) {
            if (! panel) return;
            
            if (currentTriggerElement) 
                currentTriggerElement.setAttribute('aria-expanded', 'false');
            

            panel.classList.remove('mm-active');
            panel.classList.add('mm-closing');
            removeFocusTrap(panel);

            setTimeout(() => {
                panel.classList.remove('mm-closing');
                panel.setAttribute('hidden', '');
                document.body.style.overflow = '';
                if (currentTriggerElement) {
                    currentTriggerElement.focus();
                    currentTriggerElement = null;
                }
            }, 400);
        }

        document.addEventListener('click', (e) => {
            const openBtn = e.target.closest('[data-member-open]');
            if (openBtn) {
                e.preventDefault();
                e.stopPropagation();
                const memberId = openBtn.getAttribute('data-member-open');
                const panel = document.getElementById('mm-member-panel-' + memberId);
                openPanel(panel, openBtn);
                return;
            }

            const closeBtn = e.target.closest('[data-member-panel-close]');
            if (closeBtn) {
                e.preventDefault();
                e.stopPropagation();
                const panel = closeBtn.closest('[data-member-panel]');
                closePanel(panel);
                return;
            }

            const panel = e.target.closest('[data-member-panel]');
            if (panel && e.target === panel) 
                closePanel(panel);
            
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                const activePanel = document.querySelector('[data-member-panel].mm-active');
                if (activePanel) 
                    closePanel(activePanel);
                
            }
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
		if (window.mmProductBtnVariantInit) return;
		window.mmProductBtnVariantInit = true;

		// Utilisation de window.initFocusTrap (défini dans assets/mm-access.js)
		const focusTrapCleanupMap = new WeakMap();

		function focusFirstElement(container) {
			const focusableSelectors = [
				'a[href]', 'button:not([disabled])', 'textarea:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', '[tabindex]:not([tabindex="-1"])'
			];
			const nodeList = container.querySelectorAll(focusableSelectors.join(', '));
			const focusables = Array.from(nodeList).filter(el => el.offsetParent !== null);
			const target = container.querySelector('.mm-product-card-btn-variant-content-close') || focusables[0] || container;
			if (target === container && !container.hasAttribute('tabindex')) container.setAttribute('tabindex', '-1');
			setTimeout(() => { try { target.focus(); } catch(e) {} }, 0);
		}

		/* Lazy-load des items de variante (Section Rendering API).
		   Le contenu n'est plus rendu inline : on le charge au 1er survol/clic.
		   Retourne une Promise résolue quand le panneau est prêt. */
		function loadVariants(overlay) {
			if (!overlay) return Promise.resolve();
			const state = overlay.getAttribute('data-variant-loaded');
			if (state === 'true') return Promise.resolve();
			if (overlay._mmLoadPromise) return overlay._mmLoadPromise;

			const url = overlay.getAttribute('data-variant-url');
			const container = overlay.querySelector('.mm-product-card-btn-variant-content-items-container');
			if (!url || !container) return Promise.resolve();

			container.setAttribute('aria-busy', 'true');
			overlay._mmLoadPromise = fetch(url)
				.then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
				.then(function (html) {
					/* La Section Rendering API enveloppe le rendu dans le <section>
					   du schema (tag "section"). On déballe pour ne garder que les
					   items, sinon le flex-gap du container saute (1 seul enfant). */
					const tmp = document.createElement('div');
					tmp.innerHTML = html.trim();
					const wrapper = tmp.querySelector('.mm-variant-panel-section');
					/* Si le wrapper est absent, la reponse n'est pas la section
					   attendue mais la page produit entiere (section_id ignore).
					   L'injecter dupliquerait #product-form / <variant-selector>,
					   qui ecraserait alors le prix du sticky CTA via ses
					   document.querySelector globaux. On abandonne au lieu
					   d'injecter n'importe quoi. */
					if (!wrapper) {
						throw new Error('Reponse inattendue : section mm-variant-panel absente');
					}
					container.innerHTML = wrapper.innerHTML;
					overlay.setAttribute('data-variant-loaded', 'true');
					container.setAttribute('aria-busy', 'false');
					// Recâbler les nouveaux formulaires add-to-cart injectés
					if (typeof window.initAddToCartForms === 'function') {
						window.initAddToCartForms();
					}
				})
				.catch(function (err) {
					container.setAttribute('aria-busy', 'false');
					overlay._mmLoadPromise = null;
					if (window.log) window.log('error', '🛒 [VARIANT-PANEL]', 'Fetch failed', { err: err });
				});
			return overlay._mmLoadPromise;
		}

		function openOverlay(overlay, triggerBtn) {
			overlay._mmTriggerBtn = triggerBtn || overlay._mmTriggerBtn || null;
			overlay.setAttribute('role', 'dialog');
			if (typeof window.initFocusTrap === 'function') {
				const cleanup = window.initFocusTrap(overlay, { onEscape: () => closeOverlay(overlay, true) });
				focusTrapCleanupMap.set(overlay, cleanup);
			}
			focusFirstElement(overlay);
		}

		function closeOverlay(overlay, returnFocus) {
			if (!overlay) return;
			overlay.classList.remove('mm-active');
			overlay.classList.add('mm-closing');
			if (window.startLenis) { try { window.startLenis(); } catch (e) {} }
			setTimeout(() => {
				overlay.classList.remove('mm-closing');
				overlay.setAttribute('hidden', '');
				// Refresh Splide parent pour recalculer tailles/positions
				try {
					const splideRoot = overlay.closest('.splide');
					const inst = splideRoot && (splideRoot._mmSplide || splideRoot.splide || null);
					if (inst && typeof inst.refresh === 'function') {
						inst.refresh();
					}
				} catch (e) {}
			}, 300);
			const cleanup = focusTrapCleanupMap.get(overlay);
			if (typeof cleanup === 'function') {
				try { cleanup(); } catch(e) {}
				focusTrapCleanupMap.delete(overlay);
			}
			const trigger = overlay._mmTriggerBtn || null;
			if (returnFocus && trigger) setTimeout(() => { try { trigger.focus(); } catch(e) {} }, 0);
		}

		document.addEventListener('click', function(event) {
			const clickedBtn = event.target.closest('.mm-product-card-btn-variant-btn');
			if (clickedBtn) {
				event.preventDefault();
				event.stopPropagation();
				const card = clickedBtn.closest('.mm-product-card');
				if (!card) return;
				/* Cibler l'overlay lié à CE bouton (aria-controls) : une carte peut
				   avoir 2 overlays (déclencheur mobile + desktop). */
				const controlsId = clickedBtn.getAttribute('aria-controls');
				const relatedContent = (controlsId && document.getElementById(controlsId))
					|| card.querySelector('.mm-product-card-btn-variant-content');
				if (relatedContent) {
					if (relatedContent.classList.contains('mm-active')) {
						closeOverlay(relatedContent, true);
					} else if (!relatedContent.classList.contains('mm-closing')) {
						loadVariants(relatedContent);
						if (relatedContent.hasAttribute('hidden')) {
							relatedContent.removeAttribute('hidden');
						}
						requestAnimationFrame(() => {
							void relatedContent.offsetHeight;
							relatedContent.classList.add('mm-active');
							if (window.stopLenis) { try { window.stopLenis(); } catch (e) {} }
							openOverlay(relatedContent, clickedBtn);
						});
					}
				}
				return;
			}

			const addToCartBtn = event.target.closest('.mm-product-card-btn-variant-content-btn');
			if (addToCartBtn) {
				const panel = addToCartBtn.closest('.mm-product-card-btn-variant-content');
				if (panel && panel.classList.contains('mm-active')) {
					setTimeout(() => {
						closeOverlay(panel, false);
					}, 300);
				}
				return;
			}

			const closeBtn = event.target.closest('.mm-product-card-btn-variant-content-close');
			if (closeBtn) {
				event.preventDefault();
				event.stopPropagation();
				const content = closeBtn.closest('.mm-product-card-btn-variant-content');
				if (content && content.classList.contains('mm-active')) {
					closeOverlay(content, true);
				}
				return;
			}

			const overlay = event.target.closest('.mm-product-card-btn-variant-content');
			if (overlay) {
				if (event.target === overlay) {
					event.preventDefault();
					event.stopPropagation();
					if (overlay.classList.contains('mm-active')) {
						closeOverlay(overlay, true);
					}
				}
			}
		});

		/* Préchargement : dès que l'utilisateur survole ou focus le bouton variant,
		   on charge le panneau pour que l'ouverture soit instantanée. */
		function preloadFromTrigger(event) {
			const btn = event.target.closest('.mm-product-card-btn-variant-btn');
			if (!btn) return;
			const id = btn.getAttribute('aria-controls');
			const overlay = id ? document.getElementById(id) : null;
			if (overlay) loadVariants(overlay);
		}
		document.addEventListener('mouseover', preloadFromTrigger);
		document.addEventListener('focusin', preloadFromTrigger);
	});
  } catch(e) { console.error(e); }
})();

})();
